export default {
    install(Vue) {
        // Add error handling methods to Vue prototype
        Vue.prototype.$checkoutErrorHandler = {
            showError(message, errors = null) {
                if (window.CheckoutErrorHandler) {
                    window.CheckoutErrorHandler.showError(message, errors);
                } else {
                    console.error('Checkout Error:', message, errors);
                }
            },
            
            handleApiError(error, defaultMessage = 'An error occurred while processing your request.') {
                if (error.response && error.response.data) {
                    const errorData = error.response.data;
                    
                    if (errorData.type === 'error') {
                        this.showError(errorData.message);
                    } else if (errorData.errors) {
                        this.showError('Please correct the following errors:', errorData.errors);
                    } else {
                        this.showError(defaultMessage);
                    }
                } else {
                    this.showError(defaultMessage);
                }
            },
            
            // Enhanced error parser that works with existing ErrorHandler
            parseResponseError(error, defaultMessage) {
                if (window.ErrorHandler && typeof window.ErrorHandler.parseResponseError === 'function') {
                    const errorMessages = window.ErrorHandler.parseResponseError(error, defaultMessage);
                    
                    if (errorMessages.length > 0) {
                        this.showError('Please correct the following errors:', errorMessages);
                    }
                    
                    return errorMessages;
                }
                
                return [];
            }
        };
        
        // Add global error handling mixin
        Vue.mixin({
            methods: {
                // Override existing error handling in components
                handleCheckoutError(error, context = '') {
                    const defaultMessage = context 
                        ? `${context} failed. Please try again.`
                        : 'An error occurred while processing your request.';
                    
                    this.$checkoutErrorHandler.handleApiError(error, defaultMessage);
                }
            }
        });
    }
};
